import React from "react"
import { graphql, StaticQuery, Link } from "gatsby"
import Img from "gatsby-image"
import { loadStripe } from "@stripe/stripe-js"
import Layout from "../components/layout"
import SEO from "../components/seo"

import "../utils/normalize.css"
import "../utils/css/screen.css"

let amount = ""
const handleInputChange = event => {
  const target = event.target
  const value = target.value
  amount = value
}

const stripePromise = loadStripe("pk_live_6pq8dHd7AcqIT5AhtAcunBE000dVis1jWV")

const redirectToCheckout = async event => {
  event.preventDefault()
  const stripe = await stripePromise
  const { error } = await stripe.redirectToCheckout({
    lineItems: [
      // Replace with the ID of your price
      { price: amount, quantity: 1 },
    ],
    mode: "payment",
    successUrl: `https://louiseholdenequine.co.uk/thanks`,
    cancelUrl: `https://louiseholdenequine.co.uk/pay`,
  })
  if (error) {
    console.warn("Error:", error)
  }
}

const PayPage = ({ data }, location) => {
  const siteTitle = data.site.siteMetadata.title
  console.log(data)
  return (
    <Layout title={siteTitle} location={data.location}>
      <SEO title="Pay Louise online for your lesson" />

      <article className="post-content page-template no-image">
        <div className="post-content-body">
          <h2 id="clean-minimal-and-deeply-customisable-london-is-a-theme-made-for-people-who-appreciate-simple-lines-">
            Pay Louise
          </h2>
          <div style={{textAlign: `center`}}>
          <Link className="button large pay" to={`https://buy.stripe.com/5kQdR9fGBavW6Cc7oc2sM00`}>Continue</Link>
          </div>
        </div>
      </article>
    </Layout>
  )
}

const indexQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`

export default props => (
  <StaticQuery
    query={indexQuery}
    render={data => (
      <PayPage location={props.location} data={data} {...props} />
    )}
  />
)
